"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _polished = require("polished");

var _reactIntl = require("react-intl");

var _Badge = _interopRequireDefault(require("@match/react-component-library/components/Badge"));

var _Box = _interopRequireDefault(require("@match/react-component-library/components/Box"));

var _constants = require("@match/react-component-library/components/theme/constants");

var _Text = _interopRequireDefault(require("@match/react-component-library/components/Text"));

var _theming = _interopRequireDefault(require("../../../utils/theming"));

var _components = require("../../../components");

var SubMenuItem = function SubMenuItem(_ref) {
  var customLinkRenderer = _ref.customLinkRenderer,
      route = _ref.route,
      label = _ref.label,
      count = _ref.count,
      pageCode = _ref.pageCode;
  return _react.default.createElement(_components.LinkRenderer, {
    customLinkRenderer: customLinkRenderer,
    routeHref: route,
    pageCode: pageCode
  }, _react.default.createElement(SubMenuListLink, null, _react.default.createElement(NavItem, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingX: _constants.SPACE.MEDIUM,
    paddingY: _constants.SPACE.XSMALL
  }, label && _react.default.createElement(_Text.default, {
    typography: "smallBody",
    color: "light"
  }, _react.default.createElement(_reactIntl.FormattedMessage, {
    id: label
  })), _react.default.createElement(_Box.default, {
    paddingLeft: _constants.SPACE.XSMALL,
    display: "flex"
  }, _react.default.createElement(_Badge.default, {
    count: count
  })))));
};

var _default = SubMenuItem;
exports.default = _default;
var NavItem = (0, _theming.default)(_Box.default)(function (_ref2) {
  var theme = _ref2.theme;
  return (0, _defineProperty2.default)({}, '&:hover ', {
    background: theme.palette.core1_75
  });
});
var SubMenuListLink = (0, _theming.default)(_Box.default)(function (_ref4) {
  var _ref5;

  var theme = _ref4.theme;
  return _ref5 = {
    display: 'inline-block',
    width: '100%'
  }, (0, _defineProperty2.default)(_ref5, ':focus', {
    outline: 'none',
    background: (0, _polished.transparentize)(0.85, theme.palette.core1_100)
  }), (0, _defineProperty2.default)(_ref5, '::-moz-focus-inner', {
    border: 0
  }), (0, _defineProperty2.default)(_ref5, ':focus:not(:focus-visible)', {
    boxShadow: 'none'
  }), (0, _defineProperty2.default)(_ref5, ':focus-visible', {
    background: (0, _polished.transparentize)(0.85, theme.palette.core1_100)
  }), (0, _defineProperty2.default)(_ref5, ':hover', {
    background: (0, _polished.transparentize)(0.95, theme.palette.core1_100),
    textDecoration: 'none',
    color: 'inherit'
  }), (0, _defineProperty2.default)(_ref5, 'visited', {
    color: 'inherit'
  }), _ref5;
});